import { createSlice } from "@reduxjs/toolkit";

const initialState={
    meetingCode:"",
 
}

const MeetingCodeSlice=createSlice({
    name:"meetingCode",
    initialState:initialState,
    reducers:{

        setMeetingCode:(state,action)=>{
            state.meetingCode=action.payload
        }

    }
})

export default MeetingCodeSlice.reducer;

export const{setMeetingCode}=MeetingCodeSlice.actions;
